import * as constants from '../constants';
import * as types from '../types';
import { AllStylesLandingPageApi } from '@weddingspot/ws-api-client';
import { addServerError } from './errors';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

export interface LoadAllStylesLandingPageData {
    type: constants.LOAD_ALL_STYLES_LANDING_PAGE_DATA;
    payload: types.StyleInfo[];
}

export function loadAllStylesLandingPage() {
    return function (dispatch: ThunkDispatch<types.StoreState, undefined, Action>) {
        return AllStylesLandingPageApi.getPageData()
            .then((res) => {
                dispatch({
                    type: constants.LOAD_ALL_STYLES_LANDING_PAGE_DATA,
                    payload: res,
                });
                return res;
            })
            .catch((err) => {
                dispatch(addServerError(err.status));
                return err;
            });
    };
}
